
import React from 'react';
import { Progress } from '../ui/progress';

interface ProcessingStatusProps {
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED' | 'CANCELLED';
  progress?: number;
  error?: string;
  stats?: {
    fillerWordsRemoved: number;
    processingTime: number;
    outputFileSize: number;
  };
}

const ProcessingStatus: React.FC<ProcessingStatusProps> = ({
  status,
  progress = 0,
  error,
  stats,
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'COMPLETED':
        return 'text-green-500';
      case 'FAILED':
        return 'text-red-500';
      case 'PROCESSING':
        return 'text-blue-500';
      default:
        return 'text-gray-500';
    }
  };

  return (
    <div className="p-4 border rounded-lg shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className={`font-semibold ${getStatusColor()}`}>
          Status: {status}
        </h3>
        {error && <p className="text-red-500 text-sm">{error}</p>}
      </div>

      {status === 'PROCESSING' && (
        <div className="space-y-2">
          <Progress value={progress} />
          <p className="text-sm text-gray-500">
            Processing... {progress.toFixed(1)}%
          </p>
        </div>
      )}

      {status === 'COMPLETED' && stats && (
        <div className="space-y-2">
          <div className="grid grid-cols-3 gap-4 text-sm">
            <div>
              <p className="font-medium">Filler Words Removed</p>
              <p>{stats.fillerWordsRemoved}</p>
            </div>
            <div>
              <p className="font-medium">Processing Time</p>
              <p>{stats.processingTime.toFixed(2)}s</p>
            </div>
            <div>
              <p className="font-medium">Output Size</p>
              <p>{stats.outputFileSize.toFixed(2)} MB</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProcessingStatus;
